// extracted by mini-css-extract-plugin
export default {"root":"root--IWYw3"};